'use strict';

customerZone.controller('ActivationController', ['$window', '$scope', '$log', 'SubscriptionService', 'Session', 'utils',
    'config', '$location', 'errorCode', 'salesAnalytics', 'OrderService', function($window, $scope, $log,
        SubscriptionService, Session, utils, config, $location, errorCode, salesAnalytics, OrderService){
        var self = this;

        self.iccid = undefined;
        self.simState = undefined;
        self.activation = {};
        self.sim = {};
        self.iccidLastChars = '';
        self.mnp = false;
        self.activatableSimOrders = {};

        self.activate = function(){
            if (self.activation.pending || self.activation.loading)
                return;
            self.sim = {};
            self.activation = {loading: true};

            var iccid = self.iccidLastChars || self.iccid;

            SubscriptionService.activateSubscription(iccid)
                .then(function(orderId){
                    salesAnalytics.signalEvent('activate');
                    // For now, we take the first of the orders as UWA is not returning the order yet.
                    // Anyway shouldn't happen that often
                    var activated = self.activatableSimOrders[Object.keys(self.activatableSimOrders)[0]];
                    if (activated.mnp)
                        self.activation = {mnp: true};
                    else if (activated.type === 'swap')
                        self.activation = {swap: true};
                    else
                        self.activation = {onboarding: true};
                })
                .catch(function(error){
                    if (errorCode.is(error, errorCode.ALREADY_ACTIVATING)){
                        self.activation = {pending: true, retry: true};
                    }
                    else if (errorCode.is(error, errorCode.ALREADY_ACTIVE)){
                        self.activation = {done: true};
                    }
                    else {
                        self.activation = {};
                        $log.debug('Activation request failed: '+ JSON.stringify(error));
                        if (errorCode.is(error, errorCode.UNKNOWN_SIM))
                            self.sim.unknown = true;
                        else {
                            $log.error('Activation error: ', error);
                            self.activation = {error: true};
                            utils.showError();
                        }
                    }
                });
        };

        var init = function(){
            self.loading = true;
            OrderService.getOrdersWaitingForSimMatching().then(function(waitingOrders){
                self.loading = false;
                if (waitingOrders.length === 0){
                    self.activation = {done: true};
                    self.activatableSimOrders = {};
                    return;
                }
                var activatableOrders = {};
                waitingOrders.forEach(function(order){
                    activatableOrders[order.id] = {
                        id: order.id,
                        mnp: !!order.donor,
                        type: order.type === jim.OrderType.ORDER_A_SWAP ? 'swap' : 'onboarding'
                    };
                });
                self.activatableSimOrders = activatableOrders;
                self.iccid = utils.escapeHtml($location.search()['iccid']);
                if (self.iccid && utils.checkIccid(self.iccid).valid) {
                    self.activate();
                }
            }).catch(function(error){
                utils.showError(error);
            });
        };

        init();

    }]);
